export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Ashesi University",
    desc: "Bachelors of Business Administration, Management Information Systems, Computer Science, Computer Engineering, Electrical and Electronic Engineering, Mechanical Engineering. Masters of Mechatronic Engineering.",
    link:"https://www.ashesi.edu.gh/",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "University of Ghana",
    desc: "Bachelor of Science in Information Technology, Medicine and Bachelor of Surgery, Dietetics, Medical Laboratory Sciences, Business Administration, More...",
    link:"https://www.ug.edu.gh/",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Kwame Nkrumah University of Science and Technology",
    desc: "Bachelor of Arts, Engineering, Health & Medicine, Education & Teaching, Mathematics, Biochemistry, Petroleum, Mechanical Engineering, Aerospace and More..",
    link:"https://www.knust.edu.gh/",
  },
]
export const awrapper = [
  {
    cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "50+",
    title: "Beneficiaries",
  },

  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "10+",
    title: "Scholarships",
  },
  // {
  //   cover: "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
  //   data: "1,000",
  //   title: "SCHEDULES",
  // },
  // {
  //   cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
  //   data: "587",
  //   title: "COURSES",
  // },
]
export const coursesCard = [
  {
    id: 1,
    cover: "../images/courses/c1.png",
    coursesName: "What we do?",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        desc: "We prepare high school students from low-income families in Ghanaian public schools to achieve their goals of making a positive impact in society. We work with three main objectives: (1) offering access to high-quality education and scholarships; (2) providing information on unexplored opportunities through Edu Clinic workshops; and (3) providing mentorship for career decision-making and smooth transitions. By connecting these dedicated students with the resources, they need, we aim to support the development of future leaders who will transform societies and Ghana.",
        totalTime: "50 lectures (190 hrs)",
      },
    ],
    priceAll: "$100 All Course",
    pricePer: "$15 per month",
  },
  {
    id: 2,
    cover: "../images/courses/c2.png",
    coursesName: "Our impact",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        desc: "Since our establishment in 2022, we have assisted over 10 students in obtaining scholarships to Ghanaian universities. Additionally, our social media platforms have reached over 1000 students, where we share various educational opportunities such as scholarships, internships, grants, conferences, and hackathons. We remain committed to expanding our reach to support more students who require our help in realizing their aspirations of creating positive changes in their communities in Africa.",
        totalTime: "30 lectures (125 hrs)",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },

  // {
  //   id: 3,
  //   cover: "../images/courses/c3.png",
  //   coursesName: "Scholars and where they are",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by Saroj Nepal",
  //       totalTime: "50 lectures (50 hrs)",
  //     },
  //   ],
  //   priceAll: "$50 All Course",
  //   pricePer: "$5 per month",
  // },
  // {
  //   id: 4,
  //   cover: "../images/courses/c4.png",
  //   coursesName: "Introducing to Programming with WordPress",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by Prabin Thapa Mager",
  //       totalTime: "20 lectures (20 hrs)",
  //     },
  //   ],
  //   priceAll: "$30 All Course",
  //   pricePer: "$3 per month",
  // },
  // {
  //   id: 5,
  //   cover: "../images/courses/c5.png",
  //   coursesName: "Introducing to Programming with ReactJS",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by Sunil Bishowkaram",
  //       totalTime: "100 lectures (150 hrs)",
  //     },
  //   ],
  //   priceAll: "$300 All Course",
  //   pricePer: "$30 per month",
  // },
  // {
  //   id: 6,
  //   cover: "../images/courses/c6.png",
  //   coursesName: "Learn Frontend Programming Language",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by Sunil Bishowkaram",
  //       totalTime: "200 lectures (300 hrs)",
  //     },
  //   ],
  //   priceAll: "$500 All Course",
  //   pricePer: "$80 per month",
  // },
  // {
  //   id: 7,
  //   cover: "../images/courses/c7.png",
  //   coursesName: "Introducing to with HTML / CSS",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by Price",
  //       totalTime: "20 lectures (50 hrs)",
  //     },
  //   ],
  //   priceAll: "$20 All Course",
  //   pricePer: "$2 per month",
  // },
  // {
  //   id: 8,
  //   cover: "../images/courses/c8.png",
  //   coursesName: "Introducing to with JAVA",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by Petter",
  //       totalTime: "80 lectures (200 hrs)",
  //     },
  //   ],
  //   priceAll: "$200 All Course",
  //   pricePer: "$40 per month",
  // },
  // {
  //   id: 9,
  //   cover: "../images/courses/c9.png",
  //   coursesName: "Introducing to with HTML / CSS / JAVASCRIPT",
  //   courTeacher: [
  //     {
  //       dcover: "./images/back.webp",
  //       name: "by Petter",
  //       totalTime: "50 lectures (50 hrs)",
  //     },
  //   ],
  //   priceAll: "$20 All Course",
  //   pricePer: "$3 per month",
  // },
]

export const social_media=[
    {
      id:1,
      icon:"fab fa-facebook-f icon",
      link:"https://www.facebook.com/myscholarshub/",
    },
    {
      id:2,
      icon:"fab fa-instagram icon",
      link:"https://instagram.com/myscholarshub/",
    },
    // {
    //   id:3,
    //   logo:"fab fa-twitter icon",
    //   link:"https://instagram.com/myscholarshub/",
    // },
    {
      id:3,
      icon:"fab fa-youtube icon",
      link:"https://www.youthop.com/post",
    },

    


]

export const online = [
  {
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
    courseName: "UI/UX Design Courses",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Art & Design",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Computer Science",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "History & Archeologic",
    course: "15 Courses",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Software Engineering",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Information Software",
    course: "60 Courses",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Health & Fitness",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "Marketing",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Graphic Design",
    course: "80 Courses",
  },
  {
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
    courseName: "Music",
    course: "120 Courses",
  },
  {
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
    courseName: "Business Administration",
    course: "17 Courses",
  },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Web Management",
    course: "17 Courses",
  },
]
export const team = [
  {
    cover: "./images/team/max.jpeg",
    name: "Maxwell B. Antwi",
    work: "Co-founder and President",
  },
  {
    cover: "./images/team/man.jpeg",
    name: "Mansura M. Lawal",
    work: "Co-founder and Project Cordinator",
  },
  {
    cover: "./images/team/ep.png",
    name: "Evans Kumi",
    work: "Co-founder and Software Developer",
  },
  {
    cover: "./images/team/sp.png",
    name: "Anokye Y. Mark",
    work: "Logistics Manager",
  },
  
]
export const price = [
  {
    name: "BASIC PLAN",
    price: "49K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "BEGINNER PLAN",
    price: "79K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "PREMIUM PLAN",
    price: "109k",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "ULTIMATE PLAN",
    price: "149K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
]
export const faq = [
  {
    title: "How to Enroll This Online Courses?",
    desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "Where It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How to Enroll This Online Courses?",
    desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "Where It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
]
export const blog = [
  {
    id: 1,
    location: "Ghana",
    date: "JUN. 17, 2023",
    // com: "3 COMMENTS ",
    title: "Class of 2023 Grand opening ceremony",
    desc: "Celebrate the extraordinary Class of 2023 at their grand opening ceremony, a remarkable event filled with pride, joy, and inspiration. ",
    cover: "../images/event/day1/1stm.jpeg",
  },
  {
    id: 2,
    location: "Ghana",
    date: "JUN. 17, 2023",
    // com: "5 COMMENTS ",
    title: "Preparing your college applications essays",
    desc: "Discover the key steps to excel in your college application essays and make a lasting impression on admissions committees.",
    cover: "../images//event/day1/writing.jpeg",
  },
  // {
  //   id: 3,
  //   location: "Ghana",
  //   date: "MAY. 15, 2022",
  //   // com: "10 COMMENTS ",
  //   title: "Build your Dream Software & Engineering Career",
  //   desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
  //   cover: "../images/blog/b3.webp",
  // },
  // {
  //   id: 4,
  //   type: "admin",
  //   date: "JAN. 02, 2022",
  //   com: "3 COMMENTS ",
  //   title: "Build your Dream Software & Engineering Career",
  //   desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
  //   cover: "../images/blog/b4.webp",
  // },
  // {
  //   id: 5,
  //   type: "admin",
  //   date: "DEC. 14, 2022",
  //   com: "3 COMMENTS ",
  //   title: "Build your Dream Software & Engineering Career",
  //   desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
  //   cover: "../images/blog/b5.webp",
  // },
  // {
  //   id: 6,
  //   type: "user",
  //   date: "JAN. 18, 2021",
  //   com: "12 COMMENTS ",
  //   title: "Build your Dream Software & Engineering Career",
  //   desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
  //   cover: "../images/blog/b6.webp",
  // },
]

export const opportunities = [
  {
    id: 1,
    title: "Ashesi University",
    desc: "Bachelors of Business Administration, Management Information Systems, Computer Science, Computer Engineering, Electrical and Electronic Engineering, Mechanical Engineering. Masters of Mechatronic Engineering.",
    cover: "./images/opportunities/ashesi.jpeg",
  },

  {
    id: 2,
    title: "University of Ghana",
    desc: "Bachelor of Science in Information Technology, Medicine and Bachelor of Surgery, Dietetics, Medical Laboratory Sciences, Business Administration, More...",
    cover: "./images/opportunities/uni.jpeg",
  },
  {
    id: 3,
    title: "Kwame Nkrumah University of Science and Technology",
    desc: "Bachelor of Arts, Engineering, Health & Medicine, Education & Teaching, Mathematics, Biochemistry, Petroleum, Mechanical Engineering, Aerospace and More..",
    cover: "./images/opportunities/knust.jpeg",
  },
  {
    id: 4,
    title: "University of Cape Coast",
    desc: "Bachelor of Commerce, Bachelor of Science in Nursing, Bachelor of Science in Midwifery, Bachelor of Science in Medical Laboratory Technology, Bachelor of Science in Physiotherapy, Bachelor of Science in Optometry, Bachelor of Science in Information Technology, Bachelor of Science in Computer Science, Bachelor of Science in Agriculture, Bachelor of Science in Biochemistry, Bachelor of Science in Chemistry, Bachelor of Science in Mathematics, Bachelor of Science in Physics, Bachelor of Science in Statistics, Bachelor of Science in Actuarial Science, Bachelor of Science in Meteorology and Atmospheric Physics, Bachelor of Science in Oceanography and Fisheries, Bachelor of Science in Psychology, Bachelor of Science in Environmental Science, Bachelor of Science in Fisheries and Aquatic Science, Bachelor of Science in Biochemistry, Bachelor of Science in Chemistry, Bachelor of Science in Mathematics, Bachelor of Science in Physics, Bachelor of Science in Statistics, More...",
    cover: "./images/opportunities/ucc.jpeg",
  },
  {
    id: 5,
    title: "University for Development Studies",
    desc: "Bachelor of Science in Agriculture, Bachelor of Science in Agribusiness, Bachelor of Science in Agricultural Biotechnology, Bachelor of Science in Agricultural Technology, Bachelor of Science in Family and Consumer Sciences, Bachelor of Science in Forest Resources Conservation and Management, Bachelor of Science in Renewable Natural Resources, Bachelor of Science in Irrigation Technology, Bachelor of Science in Agricultural Extension, Bachelor of Science in Agricultural Economics, Bachelor of Science in Community Nutrition, Bachelor of Science in Food Science and Technology, Bachelor of Science in Veterinary Nursing, Bachelor of Science in Veterinary Medicine, Bachelor of Science in Nursing, Bachelor of Science in Midwifery, Bachelor of Science in Community Health and Development, Bachelor of Science in Medical Laboratory Technology, Bachelor of Science in Physiotherapy, Bachelor of Science in Sonography, Bachelor of Science in Diagnostic Imaging Technology, Bachelor of Science in Medical Imaging Technology, Bachelor of Science in Medical Rehabilitation, Bachelor of Science in Environmental Health and Sanitation, Bachelor of Science in Medical Laboratory Science, Bachelor of Science in Medical Imaging Technology, Bachelor of Science in Medical Sonography, Bachelor of Science in Community Nutrition, Bachelor of Science in Dietetics, Bachelor of Science in Nursing, Bachelor of Science in Midwifery, Bachelor of Science in Community Health and Development, Bachelor of Science in Medical Laboratory Technology, Bachelor of Science in Physiotherapy, Bachelor of Science in Sonography, Bachelor of Science in Diagnostic Imaging Technology, Bachelor of Science in Medical Imaging Technology, Bachelor of Science in Medical Rehabilitation, Bachelor of Science in Environmental Health and Sanitation, Bachelor of Science in Medical Laboratory Science, Bachelor of Science in Medical Imaging Technology, Bachelor of Science in Medical Sonography, Bachelor of Science in Community Nutrition, Bachelor of Science in Dietetics, More...",
    cover: "./images/opportunities/uds.jpeg",
  }
]

export const opp = [
  {
    id: 1,
    name:'Ashesi University',
    dueDate:"by 20th August 2024",
    details:'We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams. We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams.',
    link:'https://www.ashesi.edu.gh/about.html',
    image:"./images/opp/ashesi.jpeg"
    
  },
  {
    id: 2,
    name:'University of Ghana',
    dueDate:"by 20th August 2024",
    details:'We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams. We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams.',
    link:'https://www.ug.edu.gh/',
    image:"./images/opp/uni.jpeg"
  },
  {
    id: 3,
    name:'Software Engineering',
    dueDate:"by 20th August 2024",
    details:'We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams. We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams.',
    link:'https://www.knust.edu.gh/',
    image:"./images/opp/software.jpg"
  },
  {id: 4,
  name:'Ashesi University',
  dueDate:"by 20th August 2024",
  details:'We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams. We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams.',
  link:'https://www.ashesi.edu.gh/about.html',
  image:"./images/opp/ashesi.jpeg"
  
},
{
  id: 5,
  name:'University of Ghana',
  dueDate:"by 20th August 2024",
  details:'We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams. We accept applications from students who have completed high school and have successfully passed their WASSCE exams. We also accept applications from students who have completed high school and have successfully passed their IGCSE exams.',
  link:'https://www.ug.edu.gh/',
  image:"./images/opp/uni.jpeg"
},
  


]

export const testimonal = [
  {
    id: 1,
    name: "Emmanuel Dwamena",
    post: "University of Ghana",
    desc: "Emmanuel Dwamena is a Computer Science student at University of Ghana. He is a beneficiary of the Dare2Dream Scholarship. As a Software Engineering enthusiast, he hope to employ technology to solve societal problems.",
    cover: "./images/students/st5.jpeg",
  },
  {
    id: 2,
    name: "Anokye Yaw Mark",
    post: "Kwame Nkrumah University of Science and Technology",
    desc: "Anokye Yaw Mark completed high school at Osei Kyeretwie SH, and is now a full scholarship beneficiary studying computer science. ",
    cover: "./images/students/st1.jpeg",
  },
  {
    id: 3,
    name: "Alhassan Mohammed",
    post: "Ashesi Unniversity",
    desc: "Alhassan Mohammed completed high school at Islamic Senior High School, and is now a full scholarship beneficiary studying Electrical Engineering. ",
    cover: "./images/students/st3.jpeg",
  },
  {
    id: 4,
    name: "Alhassan Furqan",
    post: "Ashesi Unniversity",
    desc: "Alhassan Furqan completed high school at Opoku Ware SHS, and is now a full scholarship beneficiary studying Electrical Engineering.",
    cover: "./images/students/st4.jpeg",
  },
 
]

export const partners=[
  {
  id:1,
  img:"./images/partners/dhs.png",
  name:"Dream Hive"
},
{
  id:2,
  img:"./images/partners/uni.jpg",
  name:"Uni Ghana"
},
{
  id:3,
  img:"./images/partners/nolb.jpg",
  name:"NOLBED Foundation"
},
]

export const services =[
  {
    id:1,
    title:"Recruit scholars",
    details:"We reach out to schools in rural areas, through conducting workshops and using online broadcasting methods, to identify students who are highly talented but come from low-income backgrounds. We distribute application forms to these students and invite them to apply to become scholars in our program. Those who are qualified are then chosen and recruited to receive our services."
  },
  {
    id:2,
    title:"Prepare our scholars",
    details:"As part of our preparation toward school and scholarship applications, we coach our scholars on how to write scholarship and school application essays, introduce them to LinkedIn, and educate them on how to send out professional e-mails.    </p>"
  },
  {
    id:3,
    title:"Support our scholars",
    details:"We assist our scholars with application fee waivers. We strive to assist our scholars in securing scholarships in top-tier universities in Ghana and abroad. While our scholars are in school, we provide them with buddy-up coaching, mentorship and job shadowing assistances. We also assist them in securing internship opportunities.    </p>"
  }
]